// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"e35d156c","118":"27006114","126":"34148873","267":"0e919b7a","564":"70ce1f02","698":"de7f05da"}[chunkId] + ".css";
};